import { createQueryKeys } from '@lukemorales/query-key-factory';

export const userApiKeyKeys = createQueryKeys('userApiKeys', {
  list: null,
});
